import * as Scrivito from "scrivito";
import spaceWidgetIcon from "../../assets/images/space_widget.svg";

Scrivito.provideEditingConfig("SpaceWidget", {
  title: "Space",
  thumbnail: spaceWidgetIcon,
  attributes: {
    size: {
      title: "Choose size (deprectated)",
      description: "Height of the space in rem. Default: 5",
    },
    customSize: {
      title: "Custom size",
      description: "Height of the space (e.g. '20px', '5rem', '10%')",
    },
    fixedSize: {
      title: "Fixed size",
      description:
        "Choose a fixed height for the space. If custom size is set, it takes precedence over this value.",
    },
  },
  properties: ["fixedSize", "customSize", ["size", { enabled: false }]],
  initialContent: {
    size: 5,
  },
});
